/**
 * Contratação pública (admindesk) — re-exporta de `@imobdesk/contracts/contratacao`.
 */
import { contratacao } from '@imobdesk/contracts'

export const contratacaoEmailFieldSchema = contratacao.contratacaoEmailFieldSchema
export const contratacaoNomeFieldSchema = contratacao.contratacaoNomeFieldSchema
export const contratacaoNomeImobiliariaFieldSchema =
  contratacao.contratacaoNomeImobiliariaFieldSchema
export const contratacaoCelularFieldSchema = contratacao.contratacaoCelularFieldSchema
export const contratacaoOnboardingFormSchema = contratacao.contratacaoOnboardingFormSchema

export type ContratacaoOnboardingForm = contratacao.ContratacaoOnboardingForm
